import { AuthService } from '../services/auth.service';

/**
 * Filtra um array de dados para incluir apenas itens que pertencem à empresa do usuário logado
 * @param data Array de dados a serem filtrados
 * @param authService Serviço de autenticação para obter o company_id do usuário
 * @param companyIdField Campo que contém o company_id no objeto (padrão: 'company_id')
 * @returns Array filtrado contendo apenas dados da empresa do usuário logado
 */
export function filterByCompanyId<T extends Record<string, any>>(
  data: T[],
  authService: AuthService,
  companyIdField: string = 'company_id',
): T[] {
  if (!data || !Array.isArray(data)) {
    return [];
  }

  const user = authService.getCurrentUser();
  if (!user || !user.company_id) {
    console.warn('Usuário não autenticado ou sem company_id. Retornando array vazio.');
    return [];
  }

  const userCompanyId = String(user.company_id);

  return data.filter((item) => {
    if (!item) return false;

    const itemCompanyId = item[companyIdField];
    if (!itemCompanyId) {
      console.warn('Item sem company_id encontrado:', item);
      return false;
    }

    return String(itemCompanyId) === userCompanyId;
  });
}

/**
 * Valida se um item pertence à empresa do usuário logado
 * @param item Item a ser validado
 * @param authService Serviço de autenticação
 * @param companyIdField Campo que contém o company_id (padrão: 'company_id')
 * @returns true se o item pertence à empresa do usuário, false caso contrário
 */
export function belongsToUserCompany<T extends Record<string, any>>(
  item: T,
  authService: AuthService,
  companyIdField: string = 'company_id',
): boolean {
  if (!item) return false;

  const user = authService.getCurrentUser();
  if (!user || !user.company_id) {
    return false;
  }

  const userCompanyId = String(user.company_id);
  const itemCompanyId = item[companyIdField];

  if (!itemCompanyId) {
    return false;
  }

  return String(itemCompanyId) === userCompanyId;
}
